// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

import VueFire from 'vuefire'
import firebase from 'firebase/app'
import 'firebase/firestore'

Vue.use(Vuetify)
Vue.use(VueFire)

// initialize your firebase app
firebase.initializeApp({
  apiKey: "AIzaSyAOMLOQpx52bK861g5w2mTEWZrb6oooHS8",
  authDomain: "bletracker-98d99.firebaseapp.com",
  projectId: 'bletracker-98d99',
  databaseURL: 'https://bletracker-98d99.firebaseio.com',
  storageBucket: "bletracker-98d99.appspot.com",
  messagingSenderId: "202883067965"
})



// save a reference to the firestore database
// to access it in the future

export const db = firebase.firestore();
// const settings = {/* your settings... */ timestampsInSnapshots: true};
// db.settings(settings);

// Enable offline persistance
// db.enablePersistence();

Vue.config.productionTip = false

Vue.mixin({
  data: function() {
    return {
      get globalVersionNumber() {
        return "1.0.4";
      }
    }
  }
})

let app;
firebase.auth().onAuthStateChanged(user => {
  if(!app) {
    app = new Vue({
      el: '#app',
      router,
      components: { App },
      template: '<App/>'
    })
  }
});



// WEBPACK FOOTER //
// ./src/main.js